import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pureSort',
    standalone: false
})
export class PureSortPipe<T> implements PipeTransform {

  transform(values: T[], sortFn: (a: T, b: T) => number): any {
    return values ? values.concat().sort(sortFn) : values;
  }
}
